import Image from "next/image";
import React from "react";

const VillaTypeTitle = ({ handleShowTips, tipOptions }) => {
  return (
    <div
      onClick={handleShowTips}
      className="flex flex-col items-start gap-1 px-4 py-1.5 xsm:border-r cursor-pointer border-[#ECEFF5]"
    >
      <span className="text-[#9DADC0] text-xs font-medium leading-normal tracking-[1.8px]">
        VİLLA TİPİ
      </span>
      <div className="flex items-center justify-between w-full">
        <span className="text-sm font-medium leading-normal tracking-tight text-themeBlack">
          {tipOptions.length === 0
            ? "Seçiniz"
            : tipOptions.length === 1
            ? tipOptions[0].label
            : `${tipOptions.length} seçildi`}
        </span>
        <Image src="/icons/down.svg" width={12} height={12} alt="icon" />
      </div>
    </div>
  );
};

export default VillaTypeTitle;
